<script>

import VendorsForm from './VendorsForm';

export default {
  props: ['replacefilters', 'changefilters'],
  components: { VendorsForm },
  data() {
    return {
      dsbl_btn: false,
      show_filters: false,
      changes: false,

      search: '',
      lives: [
        {value: '1', name: 'Live'},
        {value: '0', name: 'Not live'},
        {value: '', name: 'Live and Not live'},
      ],
      dateRange: { startDate: null, endDate: null },

      default_new_vendor: {
        status: 1,
        website: '',
        title: '',
        category: '',
        phone: '',
        email: '',
        url: '',
        location: '',
        thumbnail: '',
        content: '',
      },
      new_vendor: {},

      loading: true,
      results: [],
      pagination: {},
      filters: {
        paginate: 50,
        page: 1,
        total: 0,
        selects: [
          'id',
          'status',
          'website',
          'view_count',
          'title',
          'summary',
          'email',
          'phone',
          'url',
          'thumbnail',
          'locations',
          'categories',
          'created_at',
          'updated_at',
          'deleted_at',
        ],
        betweens: {
          created_at: {
            start: '',
            end: ''
          }
        },
        wheres: {
          status: '',
        },
        whereins: {
          website: [],
        },
        searchs: {
          search1: {
            value: ''
          }
        },
        orderbys: {

        },
      },
    }
  },
  watch: {
    'dateRange': { handler: function(n, o) {
      if(n.startDate && n.endDate && this.moment(n.startDate).isValid() && this.moment(n.endDate).isValid()) {
        this.filters.betweens.created_at.start = this.moment(n.startDate).startOf('day').format();
        this.filters.betweens.created_at.end = this.moment(n.endDate).endOf('day').format();
      } else {
        this.filters.betweens.created_at.start = '';
        this.filters.betweens.created_at.end = '';
      }
    }, deep: true },

    '$route.params.id': function (id) { if(!id) { console.log("Route param changed. Updating"); this.fetchData(); } },

    'loading': { handler: function(n, o) { this.$emit('loadchange', n) }},

    'filters.paginate': { handler: function(n, o) { this.pagination.current_page = 1; this.fetchData(); }},
  },
  created() {
    if(this.replacefilters) {
      this.filters = this.replacefilters;
    } else if(this.changefilters) {
      for(var i in this.changefilters) {
        this.filters[i] = this.changefilters[i];
      }
    }

    this.default_new_vendor.website = this.website_id;
    this.new_vendor = JSON.parse(JSON.stringify(this.default_new_vendor));

    this.fetchData();
  },
  mounted() {
    window.addEventListener('scroll', this.setStickyNav);
    window.addEventListener('resize', this.setStickyNav);
    if(document.querySelector('.table-responsive')) { document.querySelector('.table-responsive').addEventListener('scroll', this.setStickyNav); }
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.setStickyNav);
    window.removeEventListener('resize', this.setStickyNav);
    if(document.querySelector('.table-responsive')) { document.querySelector('.table-responsive').removeEventListener('scroll', this.setStickyNav); }
  },
  methods: {
    fetchData() {
      this.loading = true;
      this.filters.page = this.pagination.current_page;
      this.$http.get('/api/vendors/fetch', {params: this.filters}).then(res => {
        // console.log(res);
        this.results = res.data.data;
        this.pagination = res.data;
        this.filters.total = res.data.total;
        this.loading = false;
        this.changes = false;
      }).catch(res => { this.loading = false; this.popupErrors(res); });
    },
    add_vendor() {
      if(this.dsbl_btn == true) { this.$noty.warning('Disabled'); return; } this.dsbl_btn = true;

      this.$http.post('/api/vendors/store', this.new_vendor).then(res => {
        // console.log(res);
        this.new_vendor = JSON.parse(JSON.stringify(this.default_new_vendor));
        this.$refs.modal_add_vendor.hide();
        this.fetchData();
        this.dsbl_btn = false;
        if(res.data.id) { this.$router.push('/vendors/'+res.data.id); }
      }).catch(res => { this.dsbl_btn = false; this.popupErrors(res); });
    },
    reset_views() {
      if(this.dsbl_btn == true) { this.$noty.warning('Disabled'); return; } this.dsbl_btn = true;
      let randomid = 'id'+(Math.random() + 1).toString(36).substring(7);
      var n = new Noty({
        timeout: false,
        modal: true,
        type: 'alert', // alert, success, warning, error, info
        layout: 'center', // top, topLeft, topCenter, topRight, center, centerLeft, centerRight, bottom, bottomLeft, bottomCenter, bottomRight
        closeWith: ['button'], // click, button
        text: "Are you sure you want to reset the view count for all vendors under the selected website(s) to zero?",
        buttons: [
          Noty.button('<span id="'+randomid+'_spin" class="d-none spinner-border spinner-border-sm"></span> YES', 'btn btn-danger px-4 float-right ml-2', notyres => {
            var btn = document.getElementById(randomid), spin = document.getElementById(randomid+"_spin"), btnno = document.getElementById(randomid+"_no");
            if(btn.disabled) { this.$noty.warning('Disabled'); return; } btn.disabled = btnno.disabled = true; spin.classList.remove("d-none");
            this.$http.get('/api/vendors/resetviews', {params: this.filters}).then(res => {
              // console.log(res);
              this.dsbl_btn = btn.disabled = btnno.disabled = false; spin.classList.add("d-none");
              this.fetchData();
              n.close();
            }).catch(res => { this.popupErrors(res); this.dsbl_btn = btn.disabled = btnno.disabled = false; spin.classList.add("d-none"); });
          }, {id: randomid, 'data-status': 'ok'}),
          Noty.button('CANCEL', 'btn btn-light px-4 mr-2', notyres => {
            n.close();
          }, {id: randomid+'_no', 'data-status': 'ok'}),
        ]
      }).show().on('onClose', () => { this.dsbl_btn = false; });
    },
  }
}
</script>

<template>
  <div>
    
    <transition name="fade">
      <div class="ribbon-two ribbon-two-primary" :key="1" v-if="loading"><span><i class="spinner-border spinner-border-sm"></i></span></div>
    </transition>
    <div class="px-4 pt-4 pb-3">
      <div class="row">
        <div class="col-lg-8">
          <div class="form-inline">
            <button type="button" @click="fetchData()" class="btn btn-light mr-2 mb-2"><Icon icon="ri:refresh-line"></Icon></button>
            <div class="form-group mr-2 mb-2">
              <input type="text" class="form-control" placeholder="Search..." v-model="filters.searchs.search1.value" @change="changes = true">
            </div>
            <w-field class="mr-2 mb-2" SimpleDataType="String List, Multi" :Options="app_website_ids" v-model="filters.whereins.website" placeholder="Websites..." @input="changes = true"></w-field>
            <div class="form-group mr-2 mb-2">
              <button type="button" class="btn btn-primary dropdown-toggle" @click="show_filters ? show_filters = false : show_filters = true">Filters
                <Icon v-if="show_filters" icon="ri:arrow-drop-down-line"></Icon>
                <Icon v-else icon="ri:arrow-drop-right-line"></Icon>
              </button>
            </div>
          </div>
        </div>
        <div class="col-lg-4">
          <div class="text-lg-right mt-3 mt-lg-0">
            <button type="button" v-if="hasRole(['Dev','Admin'])" @click="reset_views" class="btn btn-danger ml-2" v-tippy content="Reset all view counts to zero"><Icon icon="ri:eye-off-line"></Icon></button>
            <!-- <button type="button" @click="export_vendors()" class="btn btn-light ml-2" v-tippy content="Export to CSV file. Includes selected filters."><Icon icon="ri:download-cloud-2-line"></Icon></button> -->
            <button type="button" @click="new_vendor = JSON.parse(JSON.stringify(default_new_vendor)); $refs.modal_add_vendor.show()" class="btn btn-success ml-2"><Icon icon="ri:add-line"></Icon> Add New</button>
          </div>
          <b-modal ref="modal_add_vendor" centered size="xl" title="Create a new vendor" :no-close-on-backdrop="true" :no-close-on-esc="true" :hide-footer="true">
            <b-form @submit.prevent="add_vendor">
              <div class="p-4">
                <VendorsForm :item="new_vendor"></VendorsForm>
              </div>
              <footer class="modal-footer">
                <button type="button" class="btn btn-light" @click="$refs.modal_add_vendor.hide()" :disabled="dsbl_btn"><Icon icon="ri:close-fill" /> Cancel</button>
                <button type="submit" class="btn btn-primary" :disabled="dsbl_btn"><span v-if="dsbl_btn" class="spinner-border spinner-border-sm"></span><Icon v-else icon="ri:save-line" /> Save</button>
              </footer>
            </b-form>
          </b-modal>
        </div>
      </div>
    </div>

    <transition name="fade">
      <div v-if="show_filters" class="form-inline px-2 pt-2 bg-gray-200">

        <div class="form-group mr-2 mb-2">
          <w-field SimpleDataType="String List, Single" v-model="filters.wheres.status" :Options="lives" placeholder="Filter by live..." @input="changes = true"></w-field>
        </div>

        <div class="form-group mr-2 mb-2">
          <w-field SimpleDataType="Date range" v-model="dateRange" placeholder="Filter by date created..." @input="changes = true"></w-field>
        </div>

        <div class="form-group mr-2 mb-2">
          <select class="form-control" v-model="filters.paginate">
            <option value="50">Per page: (50)</option>
            <option value="100">Per page: (100)</option>
            <option value="250">Per page: (250)</option>
            <option value="500">Per page: (500)</option>
            <option value="750">Per page: (750)</option>
            <option value="1000">Per page: (1000)</option>
          </select>
        </div>

      </div>
    </transition>
    <transition name="fade">
      <div v-if="changes" class="alert alert-info rounded-0 m-0">Click <Icon icon="ri:refresh-line" /> commit any changes made to filters.</div>
    </transition>
    <div class="row">
      <div class="col-sm-12">
        <div class="table-responsive m-0">
          <table class="table table-small sticky-header table-bordered-right table-hover mb-0 table-centered text-nowrap">
            <thead class="bg-white">
              <tr>
                <th class="font-weight-medium">Thumbnail</th>
                <th class="font-weight-medium"><tdsort coltext="Title" :orderby.sync="filters.orderbys.title" @do="fetchData()"></tdsort></th>
                <th class="font-weight-medium"><tdsort coltext="Website" :orderby.sync="filters.orderbys.website" @do="fetchData()"></tdsort></th>
                <th class="font-weight-medium"><tdsort coltext="Live" :orderby.sync="filters.orderbys.status" @do="fetchData()"></tdsort></th>
                <th class="font-weight-medium"><tdsort coltext="Locations" :orderby.sync="filters.orderbys.locations" @do="fetchData()"></tdsort></th>
                <th class="font-weight-medium"><tdsort coltext="Categories" :orderby.sync="filters.orderbys.categories" @do="fetchData()"></tdsort></th>
                <th class="font-weight-medium"><tdsort coltext="Email address" :orderby.sync="filters.orderbys.email" @do="fetchData()"></tdsort></th>
                <th class="font-weight-medium"><tdsort coltext="Phone number" :orderby.sync="filters.orderbys.phone" @do="fetchData()"></tdsort></th>
                <th class="font-weight-medium"><tdsort coltext="Website URL" :orderby.sync="filters.orderbys.url" @do="fetchData()"></tdsort></th>
                <th class="font-weight-medium"><tdsort coltext="Views" :orderby.sync="filters.orderbys.view_count" @do="fetchData()"></tdsort></th>
                <th class="font-weight-medium"><tdsort coltext="Last updated" :orderby.sync="filters.orderbys.updated_at" @do="fetchData()"></tdsort></th>
                <th class="font-weight-medium"><tdsort coltext="Created on" :orderby.sync="filters.orderbys.created_at" @do="fetchData()"></tdsort></th>
              </tr>
              <tr class="sticky-thead bg-white">
                <th class="font-weight-medium">Thumbnail</th>
                <th class="font-weight-medium"><tdsort coltext="Title" :orderby.sync="filters.orderbys.title" @do="fetchData()"></tdsort></th>
                <th class="font-weight-medium"><tdsort coltext="Website" :orderby.sync="filters.orderbys.website" @do="fetchData()"></tdsort></th>
                <th class="font-weight-medium"><tdsort coltext="Live" :orderby.sync="filters.orderbys.status" @do="fetchData()"></tdsort></th>
                <th class="font-weight-medium"><tdsort coltext="Locations" :orderby.sync="filters.orderbys.locations" @do="fetchData()"></tdsort></th>
                <th class="font-weight-medium"><tdsort coltext="Categories" :orderby.sync="filters.orderbys.categories" @do="fetchData()"></tdsort></th>
                <th class="font-weight-medium"><tdsort coltext="Email address" :orderby.sync="filters.orderbys.email" @do="fetchData()"></tdsort></th>
                <th class="font-weight-medium"><tdsort coltext="Phone number" :orderby.sync="filters.orderbys.phone" @do="fetchData()"></tdsort></th>
                <th class="font-weight-medium"><tdsort coltext="Website URL" :orderby.sync="filters.orderbys.url" @do="fetchData()"></tdsort></th>
                <th class="font-weight-medium"><tdsort coltext="Views" :orderby.sync="filters.orderbys.view_count" @do="fetchData()"></tdsort></th>
                <th class="font-weight-medium"><tdsort coltext="Last updated" :orderby.sync="filters.orderbys.updated_at" @do="fetchData()"></tdsort></th>
                <th class="font-weight-medium"><tdsort coltext="Created on" :orderby.sync="filters.orderbys.created_at" @do="fetchData()"></tdsort></th>
              </tr>
            </thead>
            <tbody class="">
              <router-link v-for="(item, index) in results" :key="item.id" :to="'/vendors/'+item.id" tag="tr" class="_c-pointer" exact>
                <td class="p-1" style="min-width:100px">
                  <img v-if="item.thumbnail" :src="formatImage(item.thumbnail)" class="w-100">
                  <img v-else src="@assets/images/no-image.jpg" class="w-100">
                </td>
                <td><router-link :to="'/vendors/'+item.id" class="text-inherit">{{item.title}}</router-link></td>
                <td>{{item.website}}</td>
                <td class="py-1"><div class="alert m-0" :class="item.status == 1 ? 'alert-success' : 'alert-danger'">{{item.status == 1 ? 'Yes' : 'No'}}</div></td>
                <td>
                  <div v-if="item.locations && item.locations.length" v-tippy content="Locations attached to this item">
                    <span v-for="(zet, zet_i) in item.locations" :key="zet_i" class="p-1 d-inline-block small bg-gray-100 border rounded mr-1 mb-1">{{zet}}</span>
                  </div>
                </td>
                <td>
                  <div v-if="item.categories && item.categories.length" v-tippy content="Categories attached to this item">
                    <span v-for="(zet, zet_i) in item.categories" :key="zet_i" class="p-1 d-inline-block small bg-gray-100 border rounded mr-1 mb-1">{{zet}}</span>
                  </div>
                </td>
                <td>{{item.email}}</td>
                <td>{{formatPhone(item.phone)}}</td>
                <td>{{item.url}}</td>
                <td>{{item.view_count}}</td>
                <td v-tippy :content="moment(item.updated_at).format('lll')">{{moment(item.updated_at).fromNow()}}</td>
                <td v-tippy :content="moment(item.created_at).format('lll')">{{moment(item.created_at).fromNow()}}</td>
              </router-link>
            </tbody>
          </table>
          <div class="p-3 border-top border-light">
            <w-pagination :pagination="pagination" @paginate="results=[]; fetchData()" :offset="4"></w-pagination>
          </div>
        </div>
      </div>
    </div>

  </div>



  
</template>
